












import { Zone } from '@/model/Zone';
import {Component, Prop, Vue} from 'vue-property-decorator';
import ZonePicto from '@/components/ZonePicto.vue';

export enum ZoneFilterBehaviour {
    /** Can select at most one item, no selected item means no selection */
    NONE_OR_ONE = 'none-or-one',
    /** Can select at most one item, except if no item is selected then all the items are actually selected */
    ALL_OR_ONE = 'all-or-one',
    /** Can select many items, no selected item means no selection */
    NONE_OR_MANY = 'none-or-many',
    /** Can select many items, if no item is selected then all the items are actually selected */
    ALL_OR_MANY = 'all-or-many',
    /** Cannot select anything, only for display purposes */
    READ_ONLY = 'read-only'
}

@Component({
    components: {ZonePicto}
})
export default class ZoneFilter extends Vue {
    
    @Prop({default: []}) private selectableZones: Zone[];
    @Prop({default: []}) private selectedZones: Zone[];
    @Prop({default: ZoneFilterBehaviour.NONE_OR_MANY}) private behaviour: ZoneFilterBehaviour;
    @Prop({default: () => new Map()}) private extraLabels: Map<string, string>;

    isActive(zoneCode: string): boolean {
        if (this.selectedZones.length === 0) {
            return this.behaviour === ZoneFilterBehaviour.ALL_OR_ONE
                || this.behaviour === ZoneFilterBehaviour.ALL_OR_MANY;
        }

        return this.selectedZones.find(zone => zone.zoneCode === zoneCode) != null;
    }

    toggle(zoneCode: string) {
        if (this.behaviour === ZoneFilterBehaviour.READ_ONLY) {
            return;
        }

        const selectableZone = this.selectableZones.find(zone => zone.zoneCode === zoneCode);
        const selectedZone = this.selectedZones.find(zone => zone.zoneCode === zoneCode);
        if (selectedZone != null) {
            this.selectedZones.splice(this.selectedZones.indexOf(selectedZone), 1);
            this.$emit('selectionChanged', this.selectedZones.map(zone => zone.zoneCode));
            return;
        }

        if (selectableZone == null) {
            return;
        }

        if (this.behaviour === ZoneFilterBehaviour.NONE_OR_ONE
            || this.behaviour === ZoneFilterBehaviour.ALL_OR_ONE) {
            this.selectedZones.splice(0, this.selectedZones.length);
        }

        this.selectedZones.push(selectableZone);
        this.$emit('selectionChanged', this.selectedZones.map(zone => zone.zoneCode));
    }

    get hasExtraLabels(): boolean {
        return this.extraLabels && this.extraLabels.size > 0;
    }
}
